import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, History, Users, Plus, Gift } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Home", testId: "nav-home" },
  { to: "/history", icon: History, label: "History", testId: "nav-history" },
  { to: "/asks", icon: Gift, label: "Ask", testId: "nav-ask" },
  { to: "/people", icon: Users, label: "People", testId: "nav-people" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[30rem] z-40 px-3 pb-[env(safe-area-inset-bottom)]">
      <div className="mx-2 mb-2 bg-white/90 backdrop-blur-xl border border-emerald-950/10 rounded-3xl shadow-[0_-4px_24px_rgba(13,71,54,0.10)] px-2 py-2 flex items-center justify-between">
        {items.slice(0, 2).map((it) => (
          <NavItem key={it.to} {...it} />
        ))}
        <button
          data-testid="add-debt-fab"
          onClick={() => navigate("/add")}
          className="mx-1 -mt-6 h-14 w-14 shrink-0 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center shadow-lg shadow-primary/30 transition-transform active:scale-90 hover:bg-primary/90"
          aria-label="Add a debt"
        >
          <Plus className="h-7 w-7" strokeWidth={2.5} />
        </button>
        {items.slice(2).map((it) => (
          <NavItem key={it.to} {...it} />
        ))}
      </div>
    </nav>
  );
}

function NavItem({ to, icon: Icon, label, testId }) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      data-testid={testId}
      className={({ isActive }) =>
        `flex flex-1 flex-col items-center gap-0.5 py-1.5 rounded-xl text-[11px] font-medium transition-colors ${
          isActive ? "text-primary" : "text-muted-foreground"
        }`
      }
    >
      {({ isActive }) => (
        <>
          <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
          {label}
        </>
      )}
    </NavLink>
  );
}
